<template>
  <div>
    <p>
      <span class="a-form-label">{{ $t('label-edit-business-entrepreneurs') }}*</span>
      <span class="a-form-checkbox a-form-checkbox--block" v-for="entrepreneur in entrepreneurs" :key="entrepreneur.Id">
        <input type="checkbox" :id="`entrepreneurName_${entrepreneur.Id}`" :value="entrepreneur.Id" v-model="selectedEntrepreneurs" autocomplete="edit-business entrepreneur" />
        <label :for="`entrepreneurName_${entrepreneur.Id}`">{{ entrepreneur.Name }}</label>
      </span>
      <slot></slot>
    </p>
    <p>
      <a href="javascript:void();" @click="showAddEntrepreneurPanel">{{ $t('button-add-entrepreneur') }}</a>
    </p>
    <div class="o-panel" v-if="isAddEntrepreneurPanelOpen" v-bind:class="{ 'o-panel--open': isAddEntrepreneurPanelOpen }">
      <div class="o-panel__head">
        <h2 class="o-panel__title">{{ $t('title-add-entrepreneur') }}</h2>
        <button type="button" class="o-panel__close" @click="hideAddEntrepreneurPanel">{{ $t('panel-close') }}</button>
      </div>
      <div class="o-panel__content">
        <add-entrepreneur @onEntrepreneurAdded="onEntrepreneurAdded" :businessId="businessId" />
      </div>
    </div>
    <div class="o-panel__overlay" @click="hideAddEntrepreneurPanel"></div>
  </div>
</template>

<script>
import EntrepreneurService from '@/services/entrepreneur'

import AddEntrepreneur from '@/components/form/add-entrepreneur'

export default {
  components: {
    AddEntrepreneur
  },
  props: {
    value: {
      type: Array,
      required: true
    },
    businessId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isAddEntrepreneurPanelOpen: false,
      entrepreneurs: []
    }
  },
  computed: {
    selectedEntrepreneurs: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    showAddEntrepreneurPanel: function() {
      this.isAddEntrepreneurPanelOpen = true
    },
    hideAddEntrepreneurPanel: function() {
      this.isAddEntrepreneurPanelOpen = false
    },
    refreshEntrepreneurList: async function() {
      this.entrepreneurs = await EntrepreneurService.getUserEntrepreneursByBusinessId(this.businessId)
    },
    onEntrepreneurAdded: async function(entrepreneur) {
      this.selectedEntrepreneurs.push(entrepreneur.Id)
      this.isAddEntrepreneurPanelOpen = false

      await this.refreshEntrepreneurList()
    }
  },
  async mounted() {
    await this.refreshEntrepreneurList()
  }
}
</script>
